'use client';

import { useState } from 'react';
import { useFavorites } from '@/app/providers/favorites-provider';

type FavoriteButtonProps = {
  restaurantStt: number;
  className?: string;
};

export function FavoriteButton({ restaurantStt, className = '' }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [animating, setAnimating] = useState(false);
  const fav = isFavorite(restaurantStt);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAnimating(true);
    toggleFavorite(restaurantStt);
    setTimeout(() => setAnimating(false), 300);
  };

  return (
    <button
      onClick={handleClick}
      className={`text-lg transition-transform hover:scale-110 focus-visible:ring-2 focus-visible:ring-coral-400 focus-visible:ring-offset-2 rounded ${animating ? 'animate-heart-pop' : ''} ${className}`}
      title={fav ? 'Bỏ yêu thích' : 'Yêu thích'}
      aria-label={fav ? 'Remove from favorites' : 'Add to favorites'}
    >
      {fav ? '❤️' : '🤍'}
    </button>
  );
}
